// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-0b417068] {\n  color: var(--game-list-title-color, var(--magic-tertiary, #311261));\n}\n\n.link-inner[data-v-0b417068] {\n  color: var(--magic-tertiary, #311261);\n}\n\n.game-list[data-v-0b417068] {\n  margin-top: calc(var(--magic-space, 16px) + var(--magic-space--small, 8px));\n  margin-bottom: var(--magic-space--large, 32px);\n}\n@media (min-width: 1400px) {\n  .game-list[data-v-0b417068] {\n    margin-bottom: var(--magic-space--large, 32px);\n  }\n}", ""]);
// Exports
module.exports = exports;
